module.exports = __webpack_public_path__ + "static/media/auto_insurance.0efc0ddc.png";